export default __webpack_public_path__ + "static/media/flecha.3261c28c.svg";